<template>
  <div class="page">
    <!-- header -->
    <xh-header />

    <!-- banner -->
    <ny-banner />

    <!-- 面包屑 -->
    <div class="crumbs">
      <div>会员专区 &nbsp;&nbsp;>&nbsp;&nbsp; 协会公告 &nbsp;&nbsp;>&nbsp;&nbsp; 五星体育星辰大海杯排球比赛</div>
    </div>

    <div class="ny-tabs">
      <ul>
        <li class="action">协会公告</li>
        <li>赛程公告</li>
        <li>活动信息</li>
      </ul>
    </div>

    <div class="container-width">
      <div class="detail">
        <h3 class="title">五星体育星辰大海杯排球比赛</h3>
        <p class="date">
          <img src="../../../../assets/images/date.png" />
          2021-12-30
        </p>
        <div class="content">
          <p>五星体育星辰大海杯排球比赛<br>
          五星体育星辰大海杯排球比赛五星体育星辰大海杯排球比赛五星体育星辰大海杯排球比赛五星体育星辰大海杯排球比赛五星体育星辰大海杯排球比赛五星体育星辰大海杯排球比赛五星体育星辰大海杯排球比赛五星体育星辰大海杯排球比赛</p>

        </div>
        <div class="pa">
          <div class="fl">上一条：五星体育星辰大海杯排球比赛</div>
          <div class="fr">下一条：五星体育星辰大海杯排球比赛</div>
        </div>
        <div class="view">
          <img src="../../../../assets/images/view.png" />
          阅读人数：29911人
        </div>
      </div>
    </div>
      
    <!-- footer -->
    <xh-footer />
  </div>
</template>
<script>
import XhHeader from '../../reveals/xh-header.vue'
import XhFooter from '../../reveals/xh-footer.vue'
import NyBanner from '../../sections/ny-banner.vue'

export default {
  components: {
    XhHeader,
    XhFooter,
    NyBanner
  },
  name: "Detail"
}
</script>
<style scoped>
.detail {
  padding-top: 30px;
  height: auto;
  overflow: hidden;
}
.detail h3.title {
  font-size: 36px;
  line-height: 44px;
  text-align: center;
}
.detail .date {
  margin: 12px 0;
  line-height: 18px;
  text-align: center;
}
.detail .date img {
  vertical-align: middle;
}
.detail .content {
  padding: 12px 0;
  padding-bottom: 48px;
  color: #666;
  line-height: 28px;
}
.detail .content img {
  max-width: 100%;
}
.pa {
  padding: 0 24px;
  height: 56px;
  line-height: 56px;
  background-color: #f9faff;
}
.view {
  color: #999;
  margin: 32px 0;
  line-height: 16px;
  text-align: right;
}

@media screen and (max-width: 736px) {
  
.detail h3.title {
  font-size: 22px;
  line-height: 28px;
}
.pa {
  height: auto;
  overflow: hidden;
  line-height: 24px;
} 
.pa div {
  margin: 6px 0;
  width: 100%;
}
}
</style>
